var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarWithLady(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#e8ecf0}.cls-10,.cls-4{fill:#bac0cd}.cls-5{fill:#eff3f6;stroke:#bac0cd;stroke-width:.68px;stroke-dasharray:22.76 .91 .91 1.82 5.46 .46}.cls-10,.cls-12,.cls-15,.cls-5{stroke-linecap:round}.cls-15,.cls-5{stroke-miterlimit:10}.cls-15,.cls-6{fill:#fff}.cls-7{fill:#753bbb}.cls-8{fill:#474e5e}.cls-9{fill:#8991a0}.cls-10,.cls-12{stroke:#fff;stroke-width:.81px;stroke-linejoin:round;stroke-dasharray:19.42 1.08 1.08 2.16}.cls-12{fill:transparent;stroke:#e8ecf0;stroke-width:.54px}.cls-13,.cls-18,.cls-20,.cls-21{fill:#343a5c}.cls-13{opacity:.64}.cls-15{stroke-width:.7px;stroke:#8991a0;stroke-dasharray:14.96 .93 .47 2.34}.cls-16{fill:#d3c1e9}.cls-17{fill:#b9a5d6}.cls-19{fill:#979aab}.cls-20{opacity:.7}.cls-21{opacity:.5}.cls-24{fill:#242b47}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5557",
    transform: "translate(-918 -6789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4479",
    fill: "none",
    d: "M0 0H200V110H0z",
    transform: "translate(918 6789)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(926.004 6789.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_31",
    transform: "translate(-.004 .03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20830",
    d: "M11.96 91.194c-1.132-1.362-17.048-20.838-10.3-38.355 8.768-22.77 33.912-27.453 49.865-16.661 3.79 2.576 11.178 11.831 18.4 11.96 12.7.193 35.632-48.255 64.4-48.108 19.109.1 35.743 19.054 36.074 38.825.248 14.72-12.337 23-8.161 34.657 2.861 8.188 11.647 14.812 18.75 17.112z",
    className: "cls-2",
    transform: "translate(.004 -.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4552",
    fill: "#d4d8e0",
    d: "M0 0H174.371V0.856H0z",
    transform: "translate(8.127 90.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20831",
    d: "M14.527 96.33h5.8a1.987 1.987 0 0 1 1.987 1.987H12.54a1.987 1.987 0 0 1 1.987-1.987z",
    className: "cls-4",
    transform: "translate(-1 -7.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20832",
    d: "M14.24 71h6.44v.294a1.693 1.693 0 0 1-1.693 1.693h-3.054a1.693 1.693 0 0 1-1.693-1.693z",
    className: "cls-4",
    transform: "translate(-1.136 -5.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20833",
    d: "M21.283 95.079H13.73l1.987-21.869h3.376z",
    className: "cls-4",
    transform: "translate(-1.095 -5.883)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2518",
    cx: 5.373,
    cy: 5.373,
    r: 5.373,
    className: "cls-5",
    transform: "translate(10.915 19.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20834",
    d: "M14.24 31.5h6.44v.294a1.693 1.693 0 0 1-1.693 1.693h-3.054a1.693 1.693 0 0 1-1.693-1.693z",
    className: "cls-4",
    transform: "translate(-1.136 -2.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4553",
    d: "M0 0H1.794V36.387H0z",
    className: "cls-4",
    transform: "translate(15.487 30.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20835",
    d: "M96.087 96.33h5.768a1.987 1.987 0 0 1 1.987 1.987H94.1a1.987 1.987 0 0 1 1.987-1.987z",
    className: "cls-4",
    transform: "translate(-7.523 -7.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20836",
    d: "M95.8 71h6.44v.294a1.693 1.693 0 0 1-1.693 1.693h-3.054a1.693 1.693 0 0 1-1.693-1.693z",
    className: "cls-4",
    transform: "translate(-7.659 -5.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20837",
    d: "M102.843 95.079H95.29l1.987-21.869h3.376z",
    className: "cls-4",
    transform: "translate(-7.618 -5.883)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2519",
    cx: 5.373,
    cy: 5.373,
    r: 5.373,
    className: "cls-5",
    transform: "translate(85.951 19.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20838",
    d: "M95.8 31.5h6.44v.294a1.693 1.693 0 0 1-1.693 1.693h-3.054a1.693 1.693 0 0 1-1.693-1.693z",
    className: "cls-4",
    transform: "translate(-7.659 -2.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4554",
    d: "M0 0H1.794V36.387H0z",
    className: "cls-4",
    transform: "translate(90.533 30.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4555",
    d: "M0 0H166.201V1.72H0z",
    className: "cls-4",
    transform: "translate(1.678 72.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4556",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(23.822 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4557",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(28.763 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4558",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(33.713 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4559",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(38.653 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4560",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(43.603 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20839",
    d: "M180.917 96.33h5.768a1.987 1.987 0 0 1 1.987 1.987h-9.742a1.987 1.987 0 0 1 1.987-1.987z",
    className: "cls-4",
    transform: "translate(-14.308 -7.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20840",
    d: "M180.63 71h6.44v.294a1.693 1.693 0 0 1-1.693 1.693h-3.017a1.693 1.693 0 0 1-1.693-1.693V71z",
    className: "cls-4",
    transform: "translate(-14.444 -5.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20841",
    d: "M187.673 95.079h-7.553l1.987-21.869h3.386z",
    className: "cls-4",
    transform: "translate(-14.404 -5.883)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2520",
    cx: 5.373,
    cy: 5.373,
    r: 5.373,
    className: "cls-5",
    transform: "translate(163.996 19.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20842",
    d: "M180.63 31.5h6.44v.294a1.693 1.693 0 0 1-1.693 1.693h-3.017a1.693 1.693 0 0 1-1.693-1.693V31.5z",
    className: "cls-4",
    transform: "translate(-14.444 -2.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4561",
    d: "M0 0H1.794V36.387H0z",
    className: "cls-4",
    transform: "translate(168.578 30.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4562",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(48.543 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4563",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(53.493 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4564",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(58.433 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4565",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(63.383 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4566",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(68.324 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4567",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(73.273 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4568",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(78.214 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4569",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(83.164 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4570",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(98.638 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4571",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(103.588 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4572",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(108.528 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4573",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(113.478 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4574",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(118.419 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4575",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(123.368 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4576",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(128.309 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4577",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(133.258 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4578",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(138.199 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4579",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(143.149 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4580",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(148.089 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4581",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(153.039 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4582",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(163.14 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4583",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(8.127 73.822)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2521",
    cx: 12.411,
    cy: 12.411,
    r: 12.411,
    className: "cls-6",
    transform: "translate(106.707 83.326)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2522",
    cx: 12.411,
    cy: 12.411,
    r: 12.411,
    className: "cls-6",
    transform: "translate(26.518 83.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20843",
    d: "M143.132 95.331l-1.224-.69.248-2.76.69-.856a.681.681 0 0 0 0-.8 19.238 19.238 0 0 0-5.161-5.023c-2.291-1.481-5.115-2.088-10.672-3.22a86.674 86.674 0 0 0-15.548-2h-3.551a75.682 75.682 0 0 0-10.424-6.44 49.249 49.249 0 0 0-10.175-4.223c-3.91-1.049-7.489-1.03-14.647-.994a154.922 154.922 0 0 0-19.624 1.536l-1.739.248-1.582-.773a3.22 3.22 0 0 0-1.444-.4h-.055l.221 1.49-8.611.92a5.861 5.861 0 0 0-1.509.35l-3.68 1.435 2.76.248-13.369 5.346a2.033 2.033 0 0 1-.773.156h-1.9a.331.331 0 0 0-.267.543l.442.57.745 1.242-.745.248c-.607.258-.856.745-.745.994s.4.276.745.248L20.2 84.65a1.242 1.242 0 0 0-.138 1.187l.239.607v5.5l-.175.056a.828.828 0 0 0-.57.791v.92l-.23.156a.607.607 0 0 0-.175.846l.156.239 5.52 1.38a2.484 2.484 0 0 1 .764.34l2.088 1.389c.35.239-2.466 2.852-2.042 2.87l2.962.138a12.035 12.035 0 1 1 24.068.331v.764L109 104.725a12.043 12.043 0 1 1 22.789 1.03l1.638.083a4.5 4.5 0 0 0 4.094-2.64l.423-1.049 4.6-.129 1.122-4.7a1.84 1.84 0 0 0-.064-1.076 1.932 1.932 0 0 0-.469-.911z",
    className: "cls-7",
    transform: "translate(-1.52 -5.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20844",
    d: "M24.59 79.3l13.156-5.71.745.248-11.417 4.968z",
    className: "cls-8",
    transform: "translate(-1.964 -5.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20845",
    d: "M44.826 76.326c1.187-.616 6.6-3.146 8.216-3.432 2.539-.451 21.823-2.144 27.389-2.134 6.6 0 8.216.34 8.933.5 5.17 1.141 17.618 9.927 17.618 9.927-1.086 0-16.726-.35-28.29-.994-13.506-.754-13.414-.708-17.379-.994-5.52-.4-10.194-.828-13.644-1.168a21.456 21.456 0 0 1-2.852-1.168.3.3 0 0 1 .009-.534z",
    className: "cls-9",
    transform: "translate(-3.569 -5.687)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2523",
    cx: 10.571,
    cy: 10.571,
    r: 10.571,
    className: "cls-8",
    transform: "translate(28.441 85.507)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2524",
    cx: 4.977,
    cy: 4.977,
    r: 4.977,
    className: "cls-10",
    transform: "translate(34.246 90.889)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2525",
    cx: 10.571,
    cy: 10.571,
    r: 10.571,
    className: "cls-8",
    transform: "translate(108.602 85.507)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2526",
    cx: 4.977,
    cy: 4.977,
    r: 4.977,
    className: "cls-10",
    transform: "translate(114.407 90.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20846",
    d: "M106.981 81.184S94.533 72.4 89.363 71.257c-.718-.156-2.337-.488-8.933-.5-5.13.003-21.93 1.443-26.506 2.009l-1.114.134a61.09 61.09 0 0 0-8 3.386.3.3 0 0 0 0 .534 21.457 21.457 0 0 0 2.852 1.168c1.647.166 3.579.35 5.75.534l2.263-3.459a2.374 2.374 0 0 1 1.739-1.058c6.689-.718 12.328-1.3 16.827-1.84L75.332 80l3.395.193h.791l-2.7-8.28a30.012 30.012 0 0 1 6.5.147 22.5 22.5 0 0 1 6.7 1.739 68.154 68.154 0 0 1 6.21 3.478l.764.46a.681.681 0 0 1 .3.8l-.8 2.392c5.622.171 9.937.255 10.489.255z",
    className: "cls-8",
    transform: "translate(-3.568 -5.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20847",
    fill: "rgba(0,0,0,0)",
    stroke: "#e8ecf0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.27px",
    d: "M44.826 76.326c1.187-.616 6.6-3.146 8.216-3.432 2.539-.451 21.823-2.144 27.389-2.134 6.6 0 8.216.34 8.933.5 5.17 1.141 17.618 9.927 17.618 9.927-1.086 0-16.726-.35-28.29-.994-13.506-.754-13.414-.708-17.379-.994-5.52-.4-10.194-.828-13.644-1.168a21.456 21.456 0 0 1-2.852-1.168.3.3 0 0 1 .009-.534z",
    transform: "translate(-3.569 -5.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20848",
    d: "M51.8 79.39l-3.744 3.1 1.877 9.587",
    className: "cls-12",
    transform: "translate(-3.841 -6.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20849",
    d: "M116.31 81.68l2.236 1.49 19.354 2.236 3.478 1.49-5.713 2.484-1.739 1.233",
    className: "cls-12",
    transform: "translate(-9.3 -6.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20850",
    d: "M80.16 81.41l.994 4.223.745 5.7v7.011l.248 3.174-.747 4.962",
    className: "cls-12",
    transform: "translate(-6.408 -6.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20851",
    d: "M112.27 82.22l1.481 5.713v12.991l.248 2.889-.745 2.732",
    className: "cls-12",
    transform: "translate(-8.977 -6.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20852",
    d: "M108.549 102.456l-.764-.34-38.963-3-12.411 1.021-.819-2.171A10.884 10.884 0 0 0 51.2 92.6l-1.251-.791a18.575 18.575 0 0 0-12.374-2.7l-.368.055a17.241 17.241 0 0 0-10.01 5l-.5.5-6.946-.8a.846.846 0 0 0-.2.534v.92l-.23.156a.607.607 0 0 0-.193.81l4.772 1.397h.074l.92.221a2.484 2.484 0 0 1 .764.34l2.088 1.389c.083.055 0 .258-.212.515l.672.469h.681a12.034 12.034 0 0 1 23.755.92l55.928 2.76a13.534 13.534 0 0 1-.021-1.839z",
    className: "cls-13",
    transform: "translate(-1.521 -7.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20853",
    d: "M28.527 103.625a12.347 12.347 0 0 1 .386-3.054c-.267 0-3.625-2.144-3.864-2.282l-6.081-1.38a.331.331 0 0 0-.423.276l-.322 2.466a.57.57 0 0 0-.258.754l1.242 2.668a1.582 1.582 0 0 0 .828.773l8.8 3.376a1.573 1.573 0 0 0 .276.083 11.85 11.85 0 0 1-.584-3.68z",
    className: "cls-8",
    transform: "translate(-1.429 -7.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20854",
    d: "M111.486 105.5l-39.3-3.036-16.7.331a11.767 11.767 0 0 1-.635 5.336l27.407.4h30a11.592 11.592 0 0 1-.773-3.036z",
    className: "cls-8",
    transform: "translate(-4.384 -8.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20855",
    d: "M153.455 98.83l-1.242 5.216-4.342.368s-1.288 1.242-1.794 1.233l-3.8-.055a11.789 11.789 0 0 1-.727 2.668h.856a3.5 3.5 0 0 0 .754-.074l8.115-1.665a1.84 1.84 0 0 0 1.408-1.435l.92-4.747a3.036 3.036 0 0 0-.148-1.509z",
    className: "cls-8",
    transform: "translate(-11.319 -7.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20856",
    d: "M141.1 93.311v.089a60.876 60.876 0 0 0-8.418-3.312 62.4 62.4 0 0 0-15.134-2.76l-2.76 1.987q-3.919-.662-7.94-1.242a366.976 366.976 0 0 0-45.423-3.723H57a51.226 51.226 0 0 1 10.672 8.188A51.742 51.742 0 0 1 72.392 98l5.207.5 33.01 2.484 1.086.138a12.034 12.034 0 0 1 23.939 1.306h7.958l1.73-6.136.074-2.981z",
    className: "cls-13",
    transform: "translate(-4.556 -6.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20857",
    d: "M140.32 88.342l2.484-.994a10.857 10.857 0 0 1 1.095 0 12.88 12.88 0 0 1 5.336 1.454 1.444 1.444 0 0 1 .7.828l.442 1.316h-3.229a1.978 1.978 0 0 1-.764-.147z",
    className: "cls-8",
    transform: "translate(-11.22 -7.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20858",
    d: "M21.038 80.38l.451.57.745 1.242-.745.248c-.616.258-.865.745-.745.994s.4.276.745.248l-1.352 1.923a1.27 1.27 0 0 0-.147 1.2l.248.607v5.5l-.175.055a.644.644 0 0 0-.193.1l6.7.708c.23-.331.23-.166.5-.5a23.405 23.405 0 0 1 8.565-6.615z",
    className: "cls-13",
    transform: "translate(-1.586 -6.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20859",
    d: "M110.6 78.681c.672.515 1.628 1.27 2.76 2.236h1.352a.276.276 0 0 0 .1-.534l-.589-.221h-.147a75.681 75.681 0 0 0-10.424-6.44 60.718 60.718 0 0 0-6.992-3.2l-.58.34c.442.156 1.141.414 1.987.745a53.278 53.278 0 0 1 12.533 7.074z",
    className: "cls-8",
    transform: "translate(-7.682 -5.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20860",
    d: "M20.912 82.92l1.15-.92 3.533.672a3.275 3.275 0 0 1 .837.258l2.328 1.058-2.447 1.435a2.024 2.024 0 0 1-2.226-.12l-1.5-1.113a2.19 2.19 0 0 0-.4-.23l-1.2-.58a.276.276 0 0 1-.074-.46z",
    className: "cls-8",
    transform: "translate(-1.662 -6.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20861",
    d: "M51.98 85.19h3.974a1.49 1.49 0 0 1 1.446 1.49h-6.91a1.49 1.49 0 0 1 1.49-1.49z",
    className: "cls-2",
    transform: "translate(-4.035 -6.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20862",
    d: "M84.35 86.81h3.974a1.49 1.49 0 0 1 1.49 1.49H82.86a1.49 1.49 0 0 1 1.49-1.49z",
    className: "cls-2",
    transform: "translate(-6.624 -6.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20863",
    d: "M102.837 77.37h.607a4.471 4.471 0 0 1 4.471 4.471h-4.655a2.3 2.3 0 0 1-2.3-2.3v-.3a1.84 1.84 0 0 1 1.877-1.868z",
    className: "cls-2",
    transform: "translate(-8.072 -6.216)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4584",
    width: 37.187,
    height: 41.75,
    fill: "#eff3f6",
    stroke: "#753bbb",
    strokeDasharray: "23.37 0.93 0.93 1.87 5.61 0.47",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "0.7px",
    rx: 3.18,
    transform: "translate(113.487 21.271)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2527",
    cx: 3.073,
    cy: 3.073,
    r: 3.073,
    className: "cls-7",
    transform: "translate(146.681 18.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4585",
    d: "M0 0H0.524V3.275H0z",
    className: "cls-6",
    transform: "rotate(46.89 51.864 184.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4586",
    d: "M0 0H0.524V3.275H0z",
    className: "cls-6",
    transform: "rotate(136.89 71.07 41.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_63",
    d: "M0 0L21.501 0",
    className: "cls-15",
    transform: "translate(120.792 52.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_64",
    d: "M0 0L21.501 0",
    className: "cls-15",
    transform: "translate(120.903 55.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20864",
    d: "M142.275 29.686a9.909 9.909 0 1 0 1.757 0 9.347 9.347 0 0 0-1.757 0zm6.219 7.645l-5.861 5.8a.92.92 0 0 1-1.306 0l-3.459-3.3a.94.94 0 1 1 1.325-1.334l2.76 2.668 5.216-5.152a.937.937 0 0 1 1.325 1.325z",
    className: "cls-9",
    transform: "translate(-10.654 -2.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4587",
    d: "M0 0H0.856V16.772H0z",
    className: "cls-4",
    transform: "translate(158.2 73.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20865",
    d: "M159.322 64.576a3.675 3.675 0 0 1-.4 2.475c-.543 1.638-.3 1.38-.681 2.364a13.478 13.478 0 0 1-2.263 3.744 15.042 15.042 0 0 1-2.889 2.889 3.524 3.524 0 0 0-1.61 1.84c-.147.58 0 .819-.248 1.362-.129.23-.166.184-1.205 1.251-.258.276-.4.423-.488.377s-.092-.524 0-.865c.221-.57.773-.764.708-.92s-.064 0-.166 0a1.03 1.03 0 0 0-1.021.92 3.358 3.358 0 0 0 .055.92c.046.267.147.6.064.626s-.331-.3-.451-.488a2.346 2.346 0 0 1-.478-1.978c.166-.4.515-.626 1.095-1s.57-.267.92-.506c.506-.4 1.224-1.518 3.192-5.115a15.214 15.214 0 0 1 1.233-2.116c.681-.92.92-.856 1.306-1.5.635-.984 1.84-5.52 2.631-5.354.43.098.65.918.696 1.074z",
    className: "cls-16",
    transform: "translate(-11.85 -5.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20866",
    d: "M164.4 101.931l-.267 6.229-.635.258-.451-4.775v-2.623z",
    className: "cls-17",
    transform: "translate(-13.038 -8.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20867",
    d: "M162.647 108.769h.239c.1 0 .193-.359.331-.635a1.012 1.012 0 0 1 .653-.524 1.03 1.03 0 0 1 1.067.736 6.267 6.267 0 0 1 .083.846 3.588 3.588 0 0 0 .083.846 3 3 0 0 0 .488 1.159c.184.248.267.239.331.414a1.481 1.481 0 0 1-.166 1.058c-1 0-1.785-.074-2.208-.11a.451.451 0 0 1-.414-.2c-.074-.166 0-.3 0-.635a1.564 1.564 0 0 0-.166-.635c-.184-.35-.4-.221-.57-.524a1.647 1.647 0 0 1-.083-1.058c.028-.168.102-.618.332-.738z",
    className: "cls-18",
    transform: "translate(-12.975 -8.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20868",
    d: "M163 110.42v1.132a.524.524 0 0 0 .267.46l.92.515-.322-2.006z",
    className: "cls-19",
    transform: "translate(-13.034 -8.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20869",
    d: "M163 110.42v1.067a.672.672 0 0 0 .322.561l.846.478-.322-2.006z",
    className: "cls-20",
    transform: "translate(-13.034 -8.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20870",
    d: "M162.407 111.508c-.368-.4.175-.92 0-2.438a13.224 13.224 0 0 0-.267-1.352c-.276-1.168-.432-1.408-.276-1.619.3-.4 1.408-.313 1.9.267.064.083.23.294.276 1.352.055 1.417-.2 1.628 0 2.438.156.644.4.81.267 1.086a1.408 1.408 0 0 1-1.9.266z",
    className: "cls-16",
    transform: "translate(-12.938 -8.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20871",
    d: "M161.87 111.83v1.224a.616.616 0 0 0 .221.5l.727.552-.258-2.162z",
    className: "cls-19",
    transform: "translate(-12.944 -8.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20872",
    d: "M161.87 111.83v1.15a.773.773 0 0 0 .267.607l.681.515-.258-2.162z",
    className: "cls-20",
    transform: "translate(-12.944 -8.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20873",
    d: "M162.166 110.041h.258c.11 0 .193-.4.34-.681a1.1 1.1 0 0 1 .69-.57 1.076 1.076 0 0 1 1.113.8 7.032 7.032 0 0 1 .083.92 4.394 4.394 0 0 0 .083.92 3.4 3.4 0 0 0 .515 1.251c.193.267.276.267.35.46a1.665 1.665 0 0 1-.175 1.141c-1.049 0-1.84-.083-2.318-.12a.451.451 0 0 1-.423-.23c-.083-.166 0-.322 0-.681a1.84 1.84 0 0 0-.175-.681c-.193-.377-.414-.248-.6-.57a1.84 1.84 0 0 1-.083-1.141c.029-.202.102-.726.342-.818z",
    className: "cls-7",
    transform: "translate(-12.936 -8.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20874",
    d: "M165.667 113.372a.919.919 0 0 0 0-.23c-.074-.193-.156-.193-.35-.46a2.888 2.888 0 0 1-.377-.754 1.463 1.463 0 0 0-.478-.156 1.325 1.325 0 0 0-.856.11c-.294.156-.4.35-.469.285a10.925 10.925 0 0 0 .258-1.84 3.1 3.1 0 0 0-.313-1.3 1.3 1.3 0 0 0-.248.331c-.147.285-.156.607-.34.681s-.147 0-.258 0-.313.616-.34.8a1.84 1.84 0 0 0 .083 1.141c.184.322.4.193.6.57a1.49 1.49 0 0 1 .156.552 1.674 1.674 0 0 1 1.564-.92 1.6 1.6 0 0 1 1.021.681c.062.237.18.491.347.509z",
    className: "cls-21",
    transform: "translate(-12.941 -8.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20875",
    d: "M165.667 113.372a.919.919 0 0 0 0-.23c-.074-.193-.156-.193-.35-.46a2.888 2.888 0 0 1-.377-.754 1.463 1.463 0 0 0-.478-.156 1.325 1.325 0 0 0-.856.11c-.294.156-.4.35-.469.285a10.925 10.925 0 0 0 .258-1.84 3.1 3.1 0 0 0-.313-1.3 1.3 1.3 0 0 0-.248.331c-.147.285-.156.607-.34.681s-.147 0-.258 0-.313.616-.34.8a1.84 1.84 0 0 0 .083 1.141c.184.322.4.193.6.57a1.49 1.49 0 0 1 .156.552 1.674 1.674 0 0 1 1.564-.92 1.6 1.6 0 0 1 1.021.681c.062.237.18.491.347.509z",
    className: "cls-21",
    transform: "translate(-12.941 -8.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20876",
    d: "M170.629 64.571a4.333 4.333 0 0 0-.543 2.438c-.129 1.72-.23 1.389-.267 2.438a14.914 14.914 0 0 0 .543 4.333 16.4 16.4 0 0 0 1.352 3.79 3.781 3.781 0 0 1 .672 2.3c-.074.6-.322.745-.267 1.352a8.712 8.712 0 0 0 .543 1.628c.12.35.184.543.267.543s.258-.46.276-.819c0-.616-.359-1-.276-1.076s.064 0 .156 0a1.086 1.086 0 0 1 .5 1.279 3.8 3.8 0 0 1-.377.856c-.138.221-.331.488-.276.543s.377-.147.543-.276a2.291 2.291 0 0 0 1.113-1.592 2.576 2.576 0 0 0-.543-1.352c-.267-.442-.377-.478-.543-.819-.276-.561-.469-1.84-.81-5.953a16.442 16.442 0 0 0-.276-2.438c-.239-1.067-.423-1.132-.543-1.9-.166-1.15.414-5.769-.267-5.953-.406-.093-.885.558-.977.678z",
    className: "cls-16",
    transform: "translate(-13.579 -5.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20877",
    fill: "#333a49",
    d: "M162.354 103.536a2.613 2.613 0 0 0 1.9.543 13.914 13.914 0 0 1 0-2.456 16.918 16.918 0 0 1 .718-2.824c.359-1.582-.064-1.509.267-4.057a19.264 19.264 0 0 1 .543-2.76 16.312 16.312 0 0 1 .543-1.619c.524-1.38 1.481-4.02 1.9-5.419a22.144 22.144 0 0 0 .81-6.762c0-1.4-.11-.4-.543-4.876a3.413 3.413 0 0 0-.846-2.355 2.76 2.76 0 0 0-2.162-.543c-3.183.469-4.25 8.519-4.333 13.267-.12 6.44 1.656 6.367 1.076 12.181-.351 3.393-1.299 6.788.127 7.68z",
    transform: "translate(-12.885 -5.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20878",
    d: "M160.946 71.314a13.662 13.662 0 0 0-2.429 3.79 14.849 14.849 0 0 0-1.362 7.581 21.7 21.7 0 0 0 1.362 5.143 19.413 19.413 0 0 1 1.352 4.333c.166 1.27-.055 1.242 0 3.524a23.075 23.075 0 0 0 .543 5.143 18.308 18.308 0 0 0 1.076 3.248h2.088v-2.7c0-5.52-.12-5.207-.055-7.185a29.016 29.016 0 0 0 0-2.981c-.074-1.159-.2-1.932-.267-2.438a36.227 36.227 0 0 1 0-6.229c.175-4.4.414-4.94.81-5.41.58-.708 1.159-.92 1.619-1.9a4.223 4.223 0 0 0 .276-2.7 2.87 2.87 0 0 0-1.086-1.9c-1.425-.855-3.642.313-3.927.681z",
    className: "cls-8",
    transform: "translate(-12.562 -5.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20879",
    d: "M163.616 56.659c-.359.488.3 1.095 0 2.438a4.886 4.886 0 0 0-.276 1.076 2.539 2.539 0 0 0 .543 1.628c.129.147.828 1 1.628.81a1.84 1.84 0 0 0 1.076-1.9c0-.616-.377-.662-.534-1.352-.276-1.2.6-1.84.267-2.438s-2.235-.896-2.704-.262z",
    className: "cls-16",
    transform: "translate(-13.061 -4.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20880",
    d: "M166.335 56.941a2 2 0 0 0-2.7-.267c-.331.451.2 1 .046 2.144a5.051 5.051 0 0 0 1.04.294 3.763 3.763 0 0 0 1.306 0c-.097-1.048.612-1.6.308-2.171z",
    className: "cls-17",
    transform: "translate(-13.076 -4.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20881",
    d: "M162.8 60.5c.543.819.7 1.3 1.628 1.628a1.5 1.5 0 0 0 1.076 0c.672-.285.488-.92 1.086-1.352s1.04.2 2.7 0c.58-.074.138 4.968-.267 5.41a1.38 1.38 0 0 0-.276.819 17.344 17.344 0 0 0-.267 2.7c.046 1.4.3 1.96 0 2.162s-.6-.064-1.086-.267a11.04 11.04 0 0 0-5.686-.267c-.451.092-.92.212-1.076 0s.313-.837.534-1.9a9.9 9.9 0 0 0-.258-2.972c-.193-1.214-.294-1.472-.543-1.628s-.984-3.892.276-4.057c1.759-.232 1.93-.618 2.159-.276z",
    className: "cls-7",
    transform: "translate(-12.789 -4.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20882",
    fill: "#343a5c",
    d: "M168.886 71.892c.3-.2.046-.764 0-2.162a17.344 17.344 0 0 1 .267-2.7 1.38 1.38 0 0 1 .276-.819c.4-.442.846-5.52.267-5.41-1.665.2-2.061-.432-2.7 0s-.414 1.095-1.076 1.352a1.453 1.453 0 0 1-.984 0 9.429 9.429 0 0 0 .782 2.052c.414.819.524.681.745 1.224.635 1.628-.469 2.594-.248 4.674a7.293 7.293 0 0 0 .175 1.1 6.3 6.3 0 0 1 1.426.4c.472.225.858.455 1.07.289z",
    opacity: 0.48,
    transform: "translate(-13.189 -4.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20883",
    d: "M161 62.73c.561-.6 1.03-1.049 1.352-1.352a7.512 7.512 0 0 0 .543-.543 4.251 4.251 0 0 0 .81-1.352 5.667 5.667 0 0 0-1.352-4.066 1.187 1.187 0 0 1-.267-1.086c.036.008-.166 1.609-1.086 8.399z",
    className: "cls-24",
    transform: "translate(-12.874 -4.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20884",
    d: "M160.975 61h-.92a2.309 2.309 0 0 0-1.923 1.04l-1.656 2.521a.258.258 0 0 0 .184.4l3.68.488z",
    className: "cls-7",
    transform: "translate(-12.509 -4.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20885",
    d: "M169.818 61.1h.92a1.564 1.564 0 0 1 1.555 1.463l.175 2.907a.442.442 0 0 1-.469.46l-2.208-.221z",
    className: "cls-7",
    transform: "translate(-13.577 -4.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20886",
    d: "M166.268 56.96c-.57.589 0 1.205 0 3.79 0 1.132-.129 1.638.267 2.171s.736.46 1.086 1.076a1.9 1.9 0 0 1 .267 1.362c-.12.451-.414.534-.543 1.076a2.383 2.383 0 0 0 0 .819c.156 1.049.764 2.236 1.086 2.162.147 0 .147-.294.267-.81.4-1.665 1.076-1.73 1.086-2.76s-.589-1.38-.267-1.9c.2-.322.469-.212.81-.534a2.42 2.42 0 0 0 .276-2.41c-.322-.846-.764-.7-1.352-1.628-.828-1.306-.359-2.263-1.076-2.7a1.665 1.665 0 0 0-1.907.286z",
    className: "cls-24",
    transform: "translate(-13.275 -4.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20887",
    d: "M162.734 52.457a2.962 2.962 0 0 0-.276 1.086 5.645 5.645 0 0 0 0 .81 13.083 13.083 0 0 0 0 1.352 3.828 3.828 0 0 0 .81 1.352c.478.635.718.92 1.086 1.086a1.564 1.564 0 0 0 1.086 0 1.684 1.684 0 0 0 .81-.81 6.275 6.275 0 0 0 .81-2.981c0-1.1 0-2.088-.81-2.7a2.392 2.392 0 0 0-2.438-.276 2.355 2.355 0 0 0-1.076 1.086z",
    className: "cls-16",
    transform: "translate(-12.989 -4.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20888",
    d: "M163.916 49.9a1.352 1.352 0 0 0 .276 1.628c.524.478 1.159.083 1.619.543.294.285.184.58.276 1.84a4.432 4.432 0 0 0 .534 2.438c.386.469.828.34 1.086.819s-.12 1.076-.267 2.429a5.593 5.593 0 0 0 0 1.628c.267 1.582 1.362 1.84 1.619 2.981.386 1.748-1.592 3.3-1.352 3.514s1.748-.69 2.171-2.162a4.665 4.665 0 0 0-.276-2.7c-.294-.975-.524-1.067-.81-1.9-.368-1.076-.2-1.573-.276-3.257a25.1 25.1 0 0 0-.534-4.057c-.386-1.73-.6-2.613-1.362-3.248s-2.262-1.003-2.704-.496z",
    className: "cls-18",
    transform: "translate(-13.095 -3.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20889",
    d: "M163.53 49.92c-.58-.092-1.757 1.316-1.9 1.628a9.428 9.428 0 0 0-.543 2.162c-.386 1.987-.4 2.125-.534 2.7s-.12.478-.543 2.171a13.6 13.6 0 0 0-.543 2.438c0 1.426.616 1.389.543 2.7-.064 1-.5 1.978 0 2.438.12.11.248.138.267.267.083.46-1.389.994-1.352 1.086a2.236 2.236 0 0 0 1.9-.81c.368-.524.138-.856.267-2.981a7.13 7.13 0 0 1 .276-1.9 15.8 15.8 0 0 1 .81-1.628 6.321 6.321 0 0 0 .276-2.7c0-1.325-.23-1.3-.276-2.7-.064-2.061.313-2.512.543-2.7s.635-.221.81-.543c.303-.548.459-1.555-.001-1.628z",
    className: "cls-18",
    transform: "translate(-12.709 -4.02)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWithLady);
export default __webpack_public_path__ + "static/media/car-with-lady.d5d0ea385cf52b5d3789cea2e87e204a.svg";
export { ForwardRef as ReactComponent };